import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=aa045f6a"
import script from "./LateralMenu.vue?vue&type=script&lang=js"
export * from "./LateralMenu.vue?vue&type=script&lang=js"
import style0 from "./LateralMenu.vue?vue&type=style&index=0&id=aa045f6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports